import React from "react";
import { Grid, Typography } from "@mui/material";
import DataField from "../Datafield";
import MappedText from "../../reports/create-report/shared-components/mapText";


export default function GermlineSampleAndExperiment({ selectedDir, allDataApis }) {
  return (
    <>
      <Typography variant="h5" style={{ fontWeight: "700", marginBottom: "20px" }}>
        <MappedText text={"Sample and Experiment Info"} />
      </Typography>

      <Typography variant="h6" style={{ fontWeight: "700", marginBottom: "20px" }}>
        <MappedText text={"Sample Info"} />
      </Typography>

      <Grid container spacing={2} sx={{ marginBottom: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <DataField
            title="Sample ID"
            value={allDataApis?.samples?.sampleID || "NA"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DataField
            title="Sample type"
            value={allDataApis?.samples?.sample_type || "NA"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DataField
            title="Sample site of origin"
            value={allDataApis?.samples?.sample_tissue_of_origin || "NA"}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ marginBottom: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <DataField
            title="Sample site of origin status"
            value={allDataApis?.samples?.sample_tissue_of_origin_status || "NA"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DataField
            title="Fixative"
            value={allDataApis?.samples?.fixative || "NA"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DataField
            title="Purity"
            value={allDataApis?.samples?.percentage_of_tumoral_cells || "NA"}
          />
        </Grid>
      </Grid>

      <Typography variant="h6" style={{ fontWeight: "700", marginBottom: "20px" }}>
        <MappedText text={"Experiment Info"} />
      </Typography>

      <Grid container spacing={2} sx={{ marginBottom: 4 }}>
        {selectedDir && (
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Experiment ID"
              value={selectedDir?.control_experiment_id || "NA"}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={3}>
          <DataField
            title="Library strategy"
            value={allDataApis?.experiments?.[0].library_strategy || "NA"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DataField
            title="Kit"
            value={allDataApis?.experiments?.[0].kit || "NA"}
          />
        </Grid>
      </Grid>
    </>
  );
}
